import Calculatorapp from './calculator/components/calculatorapp.vue';
import { createApp } from 'vue';


createApp({})
    .component('Calculatorapp', Calculatorapp)
    .mount("#calculatorapp");
